import { render, staticRenderFns } from "./PagerList.vue?vue&type=template&id=2ca5672d&scoped=true"
import script from "./PagerList.vue?vue&type=script&lang=js"
export * from "./PagerList.vue?vue&type=script&lang=js"
import style0 from "./PagerList.vue?vue&type=style&index=0&id=2ca5672d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca5672d",
  null
  
)

export default component.exports